import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  closeIneligibleAgeModal,
  failNoomClinicalAgeValidation,
} from "./paymentEnrollmentFormActions";

export type EnrollmentErrors = {
  name?: boolean | string;
  email?: boolean | string;
  password?: boolean | string;
  confirmPassword?: boolean | string;
  phoneNumber?: boolean | string;
  firstName?: boolean | string;
  lastName?: boolean | string;
  dateOfBirth?: boolean | string;
};

export interface PaymentEnrollmentFormState {
  hasErrors: boolean;
  enrollmentErrors: EnrollmentErrors;
  agreementValidationMessage?: string;
  enrollmentInfo: {
    name: string;
    nameChangeMade: boolean;
    email: string;
    password: string;
    confirmPassword: string;
    phoneNumber: string;
    phoneNumberCountryCode: string;
    termAgreement: boolean;
    secondaryUserSameAddressConfirmation: boolean;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    smsConsent: boolean;
    atHomeLabsConsent: boolean;
  };
  showInvalidAgeModal: boolean;
}

const initialState: PaymentEnrollmentFormState = {
  enrollmentErrors: {},
  enrollmentInfo: {
    nameChangeMade: false,
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
    phoneNumberCountryCode: "",
    termAgreement: false,
    secondaryUserSameAddressConfirmation: false,
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    smsConsent: false,
    atHomeLabsConsent: false,
  },
  hasErrors: true,
  showInvalidAgeModal: false,
};

const paymentEnrollmentFormSlice = createSlice({
  name: "paymentEnrollmentForm",
  initialState,
  reducers: {
    updatePaymentEnrollmentFormState(
      state,
      action: PayloadAction<
        Partial<Omit<PaymentEnrollmentFormState, "hasErrors">>
      >
    ) {
      const newState = { ...state, ...action.payload };
      const hasErrors = Object.keys(newState.enrollmentErrors).some(
        (key) => newState.enrollmentErrors[key]
      );
      newState.hasErrors = hasErrors;
      return newState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        failNoomClinicalAgeValidation,
        (state): PaymentEnrollmentFormState => ({
          ...state,
          showInvalidAgeModal: true,
          enrollmentInfo: {
            ...state.enrollmentInfo,
            termAgreement: false,
          },
        })
      )
      .addCase(
        closeIneligibleAgeModal,
        (state): PaymentEnrollmentFormState => ({
          ...state,
          showInvalidAgeModal: false,
        })
      );
  },
});

export const { updatePaymentEnrollmentFormState } =
  paymentEnrollmentFormSlice.actions;

export default paymentEnrollmentFormSlice;
